// @flow

import * as React from 'react';

import clsx from 'clsx';

import { useTranslator } from '@gandi/translate';
import { Hide, Svg } from '@gandi/ui';

import styles from './Breadcrumb.scss';

export type BreadCrumbProps = {
  /**
   * 1. Address
   * 2. Summary
   * 3. Payment
   * 4. Payment failed
   * 5. Confirmation (payment return success) – no breadcrumbs or menu displayed
   */
  currentStep?: 1 | 2 | 3 | 4 | 5,
};

function Crumb({
  crumb: { active, name, last },
}: {
  crumb: { active: boolean, name: string, last?: boolean },
}) {
  return (
    <li className={active ? styles.active : undefined}>
      <p>{name}</p>
      {!last && <Svg name="chevronRight" />}
    </li>
  );
}

export function Breadcrumb({
  currentStep = 1,
}: BreadCrumbProps): React.MixedElement | null {
  const { __ } = useTranslator();

  const crumbs = React.useMemo(
    () => [
      {
        name: __('Address'),
        active: currentStep === 1,
      },
      {
        name: __('Summary'),
        active: currentStep === 2,
      },
      {
        name: __('Payment'),
        active: currentStep === 3 || currentStep === 4,
        last: true,
      },
    ],
    [__, currentStep],
  );

  if (currentStep === 5) {
    return null;
  }

  return (
    <>
      <Hide until="sm">
        <div className={styles.root}>
          <ul>
            {crumbs.map(crumb => (
              <Crumb key={crumb.name} crumb={crumb} />
            ))}
          </ul>
        </div>
      </Hide>
      {/* Mobile */}
      <div className={clsx(styles.rootSmall, styles.active)}>
        {currentStep}/{crumbs.length} · {crumbs[currentStep - 1].name}
      </div>
    </>
  );
}
